import axios from "utils/axios";

// Отримати повний список файлів та папок
export const getList = async () => await axios.get('fn/list'); 

 

/**
 * Завантаження даних на сервер
 * @param {Object} uploadData 
 *      @param {Array} files                // Масив файлів з input
 *      @param {string} currentPath         // Поточний каталог
 *      @param {function} onUploadProgress  // Функція прогресу завантаження
 */
export const uploadFiles = async (uploadData) => {

    if (!uploadData?.files?.length) return;
    
    // Формуємо форму файлів з масиву файлів для відвантаження
    const formData = new FormData();
    for (let i = 0; i < uploadData.files.length; i++) {
      formData.append('files', uploadData.files[i]); // Додаємо кожен файл до FormData
    }
 
    try { 
        // Запит до сервера з відвантаженням файлів
        const response = await axios.post(`fn/upload?path=${uploadData?.currentPath||''}`, formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: uploadData?.onUploadProgress
        });
        return response.data.stat;
    } catch (error) {
        console.log(error);
        return false;
    } 
}


/**
 * Створення папки
 */
export const createFolder = async (createFolderData) => {
    try {
        const response = await axios.post(`/fn/createfolder`, createFolderData)
        return response.data.stat;
    } catch(error) {
        console.log(error);
        return false;
    }
} 


/**
 * Створення порожнього файлу
 */
export const createEmptyFile = async (createFileData) => {
    try {
        const response = await axios.post(`/fn/createfile`, createFileData)
        return response.data.stat;
    } catch(error) {
        console.log(error);
        return false;
    }
} 
 

/**
 * Переіменоуввання одного файду
 * @param {Object} renameData 
 *      @param {string} renameData.currentPath      // Поточний шлях
 *      @param {string} renameData.oldFileName      // Стара назва файлу
 *      @param {string} renameData.newFileName      // Нова назва файлу
 * @returns 
 */
export const renameOneFile = async (renameData) => {
    try {
        const response = await axios.post('/fn/rename', renameData);
        return (response.data.stat) ? response.data.fileName : false;
    } catch(error) {
        console.log(error);
        return false;
    }
}


/** 
 * Видалення файлів 
 * @param {array} aFiles  // Масив файлів для видалення (з повним шляхом) 
 */
export const deleteFiles = async (aFiles) => {
    try {
        const response = await axios.post('/fn/delete', {files:aFiles});
        return response.data.stat;
    } catch(error) {
        console.log(error);
        return false;

    }
} 


/**
 * 
 * @param {object} pasteData 
 *      @param {string} pasteData.oper          // copy або move
 *      @param {string} pasteData.files         // Архів файлів з повним шляхо
 *      @param {string} pasteData.destination   // Кінцева папка
 */ 
export const clipPaste = async (pasteData) => {
    try {
        const response = await axios.post(`/fn/oper/${pasteData.oper}`, pasteData);
        return response.data.stat;

    } catch (error) {
        console.log(error);
        return false;
    }
}


/**
 * Встановлює аабо змімає признак приватності
 * @param {Object} pData 
 *      @param {string} pData.file          // Назва файлу з повним шляхом
 *      @param {bool} pData.private         // признак приватності
 * @returns 
 */
export const setPrivate = async (pData) => {
    try {
        const response = await axios.post(`/fn/private`, pData);
        return response.data.stat;
    } catch (error) {
        console.log(error);
        return false;
    }   
}

/**
 * 
 * @param {Object} downloadData 
 *      @param {Array} fileUrls
 *      @param {string} destination
 */
export const downloadUrls = async (downloadData) => {
    try {
        const response = await axios.post('/fn/download', downloadData)
        return response?.data?.stat||false;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Отримуємо proxy url Для файлу
 * @param {string} fileName 
 * @returns 
 */
export const getProxyUrl = async (fileName) => {
    try {
        const response = await axios.get('/proxy/url', {params:{fileName:fileName}});
        return response.data?.proxyUrl||null;
    } catch(e){
        console.error(e);
        return null;
    }
}


export const getFileDataByUrl = async (urlFile) => {
    try {

    } catch(e) {
        console.log(e);
    }
}